var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"trexte_services-1"},[_c('div',{staticClass:"transport-camion isidorasansalt-bold-magic-potion-15px"},[_vm._v(_vm._s(_vm.transportCamion))]),_c('p',{staticClass:"dpanneuse-plateau-porte-5-ou-8 montserrat-normal-magic-potion-14px"},[_vm._v(_vm._s(_vm.dpanneusePlateauPorte5Ou8))])])
}
var staticRenderFns = []

export { render, staticRenderFns }